import { render, staticRenderFns } from "./share-split-payment-record.vue?vue&type=template&id=56685e2a&scoped=true"
import script from "./share-split-payment-record.vue?vue&type=script&lang=js"
export * from "./share-split-payment-record.vue?vue&type=script&lang=js"
import style0 from "./share-split-payment-record.vue?vue&type=style&index=0&id=56685e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56685e2a",
  null
  
)

export default component.exports